import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageToggle.css';

export function LanguageToggle({ className = '' }) {
  const { locale, setLocale, t } = useLanguage();

  return (
    <div
      className={`lang-toggle ${className}`.trim()}
      role="group"
      aria-label={t('lang.label')}
    >
      <button
        type="button"
        className={`lang-toggle-btn ${locale === 'sr' ? 'active' : ''}`}
        onClick={() => setLocale('sr')}
        aria-pressed={locale === 'sr'}
      >
        {t('lang.sr')}
      </button>
      <button
        type="button"
        className={`lang-toggle-btn ${locale === 'en' ? 'active' : ''}`}
        onClick={() => setLocale('en')}
        aria-pressed={locale === 'en'}
      >
        {t('lang.en')}
      </button>
    </div>
  );
}
